<div id="dashboard-section-basic-info-info" class="content-box_module__333d9 content-box_lg__3v3a- mb-10">
  <div class="content-box_body__3tSRB">
    <header class="content-box_header__xPnGx clearfix">
      <div class="wil-float-left">
        <h4 class="content-box_title__1gBHS">
          <span>ORDER DETAILS</span>
        </h4>
      </div>
    </header>
    <ng-container *ngIf="order$ | async as order">
      <app-order-details [order]="order"></app-order-details>
      <form
        *ngIf="isCustomerOrder$ | async"
        (ngSubmit)="submitOrderStatus()"
        [formGroup]="statusForm"
        style="display: flex"
      >
        <mat-form-field appearance="fill" style="margin-bottom: -1.75rem; margin-right: 0.5rem">
          <mat-label>Order Status</mat-label>
          <mat-select formControlName="status">
            <mat-option *ngFor="let opt of statusOptions" [value]="opt">{{ opt }}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-flat-button type="submit" color="primary" style="min-width: 100px">SAVE</button>
      </form>
    </ng-container>
  </div>
</div>
